<template>
    <div class="anm22-task-headmenu">
      <!-- Header con menu di navigazione della pagina di gestione di un progetto -->
      <div
          v-for="(item, index) in items"
          :key="'header-'+index" 
          :class="['item', selected === item.id ? 'selected' : '']"
          @click="selectPage(item.id)">
        <img :src="item.img" />
        <div class="label">{{ $anm22.strLang(lang, item.labelEn, item.labelIt) }}</div>
      </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: ['selected'],
  data() {
    return {
      items: [
        {
          id: 'tasks',
          img: this.$anm22.icons.getTasksIcon('tasksBlack'),
          labelEn: "Tasks",
          labelIt: "Attività",
        },
        {
          id: 'events',
          img: this.$anm22.icons.getTasksIcon('eventsBlack'),
          labelEn: "Events",
          labelIt: "Turni",
        },
        {
          id: 'expenses',
          img: this.$anm22.icons.getTasksIcon('expensesBlack'),
          labelEn: "Expenses",
          labelIt: "Spese",
        },
        {
          id: 'statistics',
          img: this.$anm22.icons.getTasksIcon('statisticsBlack'),
          labelEn: "Statistics",
          labelIt: "Statistiche",
        }
      ]
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
    }),
  },
  methods: {
    selectPage(page) {
      this.$emit('selectPage', page);
    }
  }
};
</script>

<style lang="scss" scoped>
.anm22-task-headmenu {
  height: 45px;

  .item {
    cursor: pointer;

    img {
      display: inline-block;
      vertical-align: middle;
    }
    .label {
      display: inline-block;
      vertical-align: middle;
      font-size: 14px;
      padding-left: 6px;
      opacity: 0.6;
      font-weight: 500;

      @media screen and (max-width: 768px){
        display: none;
      }
    }

    &.selected,
    &:hover {
      img,
      .label {
        opacity: 1;
      }
    }
  }
}
</style>

